import type { ReactNode } from 'react';
import type { WorkspaceMode } from './ShellLayoutContext';

interface ShellPageProps {
  /** Matches the route's workspaceMode so loading/empty states keep shell geometry. */
  mode: WorkspaceMode;
  children: ReactNode;
  className?: string;
  testId?: string;
}

/**
 * Canonical primary-workspace page wrapper (Stage 18).
 * Prefer this over ad-hoc `page` / `page--*` class combinations on primary routes.
 */
export function ShellPage({ mode, children, className, testId }: ShellPageProps) {
  const extras = className ? ` ${className}` : '';
  return (
    <div className={`page page--${mode}${extras}`} data-testid={testId}>
      {children}
    </div>
  );
}
